import * as types from './mutation-types'
import Vue from 'vue'

export default {
  [types.RECEIVED_SERVICE] (state, { service }) {
    Vue.set(state, 'service', service)
  },
  [types.RECEIVED_CURRENT_TICKETS] (state, { currentTickets }) {
    state.currentTickets = currentTickets
  },
  [types.RECEIVED_CURRENT_TICKET] (state, { ticket }) {
    state.currentTicket = ticket
  },
  [types.RECEIVED_WORKER] (state, { worker }) {
    state.worker = worker
  },
  [types.RECEIVED_WORKERS] (state, { workers }) {
    state.workers = workers
  },
  [types.RECEIVED_LOGGED_USER] (state, { loggedUser }) {
    state.loggedUser = loggedUser
  },
  [types.RECEIVED_DEVICES] (state, { devices }) {
    state.devices = devices
  },
  [types.RECEIVED_NEXT_TICKET] (state, { nextTicket }) {
    state.nextTicket = nextTicket
  },
  [types.RECEIVED_NEXT_TICKETS] (state, { nextTickets }) {
    state.nextTickets = nextTickets
  },
  [types.RECEIVED_TICKETS_WAITING_COUNT] (state, { ticketsWaitingCount }) {
    state.ticketsWaitingCount = ticketsWaitingCount
  },
  [types.RECEIVED_NEWS] (state, { news }) {
    state.news = news
  },
  [types.RECEIVED_NOTIFIERS] (state, { notifiers }) {
    state.notifiers = notifiers
  },
  [types.RECEIVED_SERVICES] (state, { services }) {
    Vue.set(state, 'services', services)
  },
  [types.RECEIVED_USERS] (state, { users }) {
    state.users = users
  },
  [types.RECEIVED_FENIX_USER] (state, { user }) {
    state.currentUser = user
  },
  [types.CLEAR_FENIX_USER] (state) {
    state.currentUser = null
  },
  [types.RECEIVED_QUEUE_UPDATE] (state, { letter, newTicket, nextTicket }) {
    Object.keys(state.ticketsWaitingCount).map((k) => {
      if (k === letter) {
        Vue.set(state.ticketsWaitingCount, k, state.ticketsWaitingCount[k] - 1)
      }
    })

    for (let i = 0; i < state.currentTickets.length; i++) {
      const element = state.currentTickets[i]
      if (element.letter === letter) {
        Vue.set(state.currentTickets, i, newTicket)
      }
    }

    for (let i = 0; i < state.nextTickets.length; i++) {
      const element = state.nextTickets[i]
      if (element && element.letter === letter) {
        Vue.set(state.nextTickets, i, nextTicket)
      }
    }
  },
  [types.DELETE_SERVICE] (state, { serviceID }) {
    state.services = state.services.filter((service) => {
      return service.id !== serviceID
    })
  },
  [types.SET_CURRENT_TICKET] (state, { ticket }) {
    state.ticket = ticket
  },
  [types.CLEAR_SERVICE_CONTEXT] (state) {
    state.service = undefined
  }
}
